import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import get from 'utils/get';
import slugify from 'utils/slugify';
import flattenMediaData from 'utils/flattenMediaData';
import contentfulImgUtil from 'utils/contentfulImgUtil';
import ImageWidth from 'constants/ImageWidth';
import constantize from 'utils/constantize';
import marked from 'marked';
import imageModel from 'models/imageModel';
import withBreakpoint from 'lib/withBreakpoint';

import { Image } from 'components/base';

const CaptionImageBlock = ({ block, breakpointData }) => {
  const title = get(block, 'title', '');
  const text = get(block, 'text', '');
  const image = flattenMediaData(get(block, 'image', {}));
  const positionX = get(block, 'positionX', 0);
  const positionY = get(block, 'porisionY', 0);
  const textPosition = slugify(get(block, 'textPosition', 'Bottom'));
  const textAlign = slugify(get(block, 'textAlign', 'Start'));
  const imageSize = get(block, 'imageSize', 'none');
  const imageSizeByHeight = get(block, 'imageSizeByHeight', 'none');
  const textWidthSmall = get(block, 'textWidthSmall', false);
  const imageSizeNumber = get(ImageWidth, constantize(imageSize), 1000);
  const showBlockTitle = get(block, 'showBlockTitle', false);
  const textPositionIsBottom = textPosition === 'bottom';

  return (
    <div
      style={
        breakpointData.breakpointIsLarge ||
        breakpointData.breakpointIsExtraLarge
          ? {
              marginTop: `${positionY}%`,
              marginLeft: `${positionX}%`
            }
          : {}
      }
      className={cx(`CaptionImageBlock relative flex lg:m1 flex-col w100`, {
        'lg:flex-row': textPosition === 'right',
        'lg:flex-col': textPositionIsBottom,
        'lg:flex-row-reverse': textPosition === 'left',
        'items-start': textAlign === 'start',
        'items-center': textAlign === 'center',
        'items-end': textAlign === 'end',
        guideline: showBlockTitle
      })}
    >
      {showBlockTitle ? (
        <p className="block-title absolute r0 t0">{title}</p>
      ) : null}
      <div className="lg:p1 w100">
        <Image
          className={`fit-contain image-width-${slugify(
            imageSize
          )} image-height-${slugify(imageSizeByHeight)}`}
          src={contentfulImgUtil(get(image, 'url', ''), imageSizeNumber)}
          alt={get(image, 'description', '')}
        />
      </div>
      {!!text && (
        <div
          className={cx(
            'CaptionImageBlock__text caption caption-text-width markdown-text my1 mx2_5 lg:my1 lg:mx1',
            {
              'text-right': textPosition === 'left',
              'caption-text-width-small': textWidthSmall
            }
          )}
          dangerouslySetInnerHTML={{
            __html: marked(text)
          }}
        />
      )}
    </div>
  );
};

CaptionImageBlock.propTypes = {
  block: PropTypes.shape({
    image: imageModel.proptypes,
    positionX: PropTypes.number,
    positionY: PropTypes.number,
    textPosition: PropTypes.string,
    textAlign: PropTypes.string,
    imageSize: PropTypes.string,
    imageSizeByHeight: PropTypes.string,
    textWidthSmall: PropTypes.bool,
    title: PropTypes.string,
    showBlockTitle: PropTypes.bool
  })
};

CaptionImageBlock.defaultProps = {
  block: {
    image: imageModel.default,
    positionX: 0,
    positionY: 0,
    textPosition: 'Bottom',
    textAlign: 'Start',
    imageSize: 'none',
    imageSizeByHeight: 'none',
    textWidthSmall: false,
    title: '',
    showBlockTitle: false
  }
};

export default withBreakpoint(CaptionImageBlock);
